export default {"src":"/_next/static/media/shield-border.ddaef957.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};